/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../../components/auth/auth-constants';
import {TeamGroupResource} from '../../../components/api/resources/resource/team-group.resource';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-team-group-route-page',
  template: `
    <adn-team-group-list-page
      *ngIf="list"
      [list]="list">
    </adn-team-group-list-page>
  `
})
export class TeamGroupRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(TeamGroupResource) private readonly TeamGroup: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageSystem.apiKey)
      && !this.LocalUserPermissions.hasDataNetworkPermission(PERMISSIONS.dataAdmin.apiKey)
      && !this.LocalUserPermissions.hasNetwork(PERMISSIONS.axAdvertiserAdmin.apiKey);

    this.adnListHelper.setUpList(this.list, this.TeamGroup, readOnly, 'fullTeamGroupList', {
      baseTable: 'teamGroup'
    });
  }
}
